module.exports = __webpack_public_path__ + "static/media/Logo-Black.0da0eb6d.png";